// Function to remove content after the slash
function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
            clearInterval(interval);
            trigger();
        }
    }, delayInterval);
    setTimeout(function () {
        clearInterval(interval);
    }, delayTimeout);
}

function updateRatingSnippet() {
    const ratingElement = document.querySelectorAll('.ruk_rating_snippet');
    const secondSpan = document.querySelectorAll('.ruk_rating_snippet span:nth-of-type(2)');
    console.log("data get!!", secondSpan);
    // Check if the second span exists
    ratingElement.forEach((ele)=>{
        ele.style.visibility = "visible";
    })
    secondSpan.forEach((ele)=>{
        ele.innerHTML = ele.innerHTML.replace(/ \/ .*/, '');
    })
}

document.addEventListener("DOMContentLoaded", (event) => {
    console.log("load the page!!");
    waitForElement(".ruk_rating_snippet", updateRatingSnippet, 350, 5000);   
    waitForElement(".R-ReviewsList", showSliderArrow, 350, 5000);   
     
});


function showSliderArrow() {
    document.querySelector('.R-ReviewsList__controlButton--right').addEventListener('click', function(){
        document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
    });
    document.querySelectorAll('.R-ReviewsList__item').forEach(function(item) {
        let touchStartX = 0;
        let touchEndX = 0;

        // Listen for the start of the touch
        item.addEventListener('touchstart', function(event) {
            touchStartX = event.changedTouches[0].screenX;
        });

        // Listen for the end of the touch
        item.addEventListener('touchend', function(event) {
            touchEndX = event.changedTouches[0].screenX;
            handleSwipe();
        });

        // Function to determine if it was a swipe left or right
        function handleSwipe() {
            if (touchEndX < touchStartX) {
                console.log('Swiped left');
                document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
            }
            if (touchEndX > touchStartX) {
                console.log('Swiped right');
                document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
            }
        }
    });
};


// let lastScrollTop = 0;

// function checkSteps() {
//     let windowTop = $(window).scrollTop();
//     let windowHeight = $(window).height();
//     let windowBottom = windowTop + windowHeight;
//     let triggerPoint = windowBottom - 250;

//     let isScrollingDown = windowTop > lastScrollTop;

//     $(".eq-logo-mat-process__step").each(function () {
//         let elementTop = $(this).offset().top;

//         // SCROLL DOWN → only add class
//         if (isScrollingDown) {
//             if (elementTop < triggerPoint) {
//                 $(this).addClass("active");
//             }
//         }

//         // SCROLL UP → remove class only if element is below viewport
//         else {
//             if (elementTop > windowBottom) {
//                 $(this).removeClass("active");
//             }
//         }
//     });

//     lastScrollTop = windowTop <= 0 ? 0 : windowTop;
// }

// $(window).on("scroll", checkSteps);
// checkSteps();

let lastScrollTop = 0;

    function checkSteps() {

        let windowTop = $(window).scrollTop();
        let windowHeight = $(window).height();
        let windowBottom = windowTop + windowHeight;

        let isScrollingDown = windowTop > lastScrollTop;

        let steps = $(".eq-logo-mat-process__step");

        // 🔽 SCROLL DOWN → Add Active
        if (isScrollingDown) {

            steps.each(function () {

                let elementTop = $(this).offset().top;

                if (elementTop < windowBottom - 300) {
                    $(this).addClass("active");
                }

            });

        }

        // 🔼 SCROLL UP → Remove One By One
        else {

            // Get last active element only
            let lastActive = $(".eq-logo-mat-process__step.active").last();

            if (lastActive.length) {

                let elementTop = lastActive.offset().top;

                // Remove when element goes 250px below viewport bottom
                if (elementTop > windowBottom - 300) {
                    lastActive.removeClass("active");
                }
            }
        }

        lastScrollTop = windowTop <= 0 ? 0 : windowTop;
    }

    $(window).on("scroll", checkSteps);
    checkSteps();